// extracted by mini-css-extract-plugin
export default {"mortgage":"BasicMortgage_mortgage__d23jy","mortgage__title":"BasicMortgage_mortgage__title__pXXFY","main__title":"BasicMortgage_main__title__yK3pS"};